export default __webpack_public_path__ + "static/media/mon_24.48355d3f.png";